/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    getBadges() {
      $.ajax({
        url: "/ping/badges?last=" + this.data.get("lastact"),
        type: "GET",
        success: function(json) {
          console.log("new_messages => " + json.new_messages + " // new_activities => " + json.new_activities);
          if (json.new_messages > 0) {
            $("#unread_messages_badge").text(json.new_messages).removeClass('hidden');
          } else {
            $("#unread_messages_badge").addClass('hidden');
          }
          if (json.new_activities > 0) {
            $("#unseen_activities_badge").text(json.new_activities).removeClass('hidden');
          } else {
            $("#unseen_activities_badge").addClass('hidden');
          }
        },
        dataType: "json",
        timeout: 15000
      })
    }

    startRefreshing() {
      this.mobileTimer = setInterval(() => {
        this.getBadges();
      }, 10000)
    }

    stopRefreshing() {
      if (this.mobileTimer) {
        clearInterval(this.mobileTimer)
      }
    }

    initialize() {
    }

    connect() {
      // console.log("-=> mobile_controller connected");

      this.getBadges();
      this.startRefreshing();


      $('.abstrettaflash')
        .delay(4000)
        .queue(function() {
            $(this).transition('fade out').dequeue();
        });
    }


    disconnect() {
      this.stopRefreshing();
    }

  };
  // console.log("-=> mobile_controller loaded");


